import React from 'react';
import searchResource from '../../../locales/th/search.json';
import { Description, Header } from './NoResultMessage.style';

const NoResultMessage: React.FC = () => {
  return (
    <>
      <Header>{searchResource.noProjectSearchResult.title}</Header>
      <Description>
        {searchResource.noProjectSearchResult.description}
      </Description>
    </>
  );
};

export default NoResultMessage;
